import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FeatureTogglesModel } from "@core/models/feature-toggles";
import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root"
})
export class FeatureToggleService {
  public toggles: FeatureTogglesModel;

  constructor(private http: HttpClient) {}

  private readonly featureTogglesString = "feature-toggles";
  public featureToggles$: Observable<FeatureTogglesModel> = this.http
    .get<FeatureTogglesModel>(
      `${environment.apiUrl}${this.featureTogglesString}`
    )
    .pipe(shareReplay(1));

  public isEnabled(flag: keyof FeatureTogglesModel): boolean {
    return !!this.toggles?.[flag];
  }

  verifyFeatureToggle() {
    return this.featureToggles$;
  }
}
